import './PersonalDataPage.scss';

const PersonalDataPage: React.FC = () => {
  return (
    <div className="personal-data">
      <div className="container personal-data__content">
        <br />

        <iframe
          title="Privacy policy"
          src="/policies/privacy.html"
          style={{ position: 'initial', width: '100%', height: '100%', overflow: 'hidden' }}
          scrolling="no"
          allowFullScreen={false}
          onLoad={(e) => {
            e.currentTarget.style.height = e.currentTarget.contentDocument?.body.scrollHeight + 'px';
          }}
        />
      </div>
    </div>
  );
};

export default PersonalDataPage;
